import { BaseVO, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { mixerId } from "../../schema";
import { MixerId } from "../../interface";

export class MixerErrorVO extends BaseVO<MixerError> {
  private static validation = JsonSchemaValidator.compile(
    MixerErrorVO.validationSchema()
  );

  constructor(value: MixerError) {
    super(JsonSchemaValidator.assert(MixerErrorVO.validation, value));
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["error", "mixerId", "streamId"],
      properties: {
        error: { type: "object" },
        mixerId,
        streamId
      },
      additionalProperties: false
    };
  }
}

interface MixerError {
  error: Error;
  mixerId: MixerId;
  streamId: StreamId;
}
